<template>
    <div>
        <Button
          :label="'VER RELATÓRIO'"
          icon="pi pi-eye"
          class="p-button-raised p-button-secondary p-button-sm"
          @click="showPreview = true"
        />
        <Dialog
            id="preview-report"
            :visible.sync="showPreview"
            :style="{ width: $isMobile() ? '100vw' : '80vw' }"
            header="Preview do Relatório"
            :modal="true"
            :closable="false"
            >
            <Loading
              :active.sync="loading"
              :isFullPage="false"
              :zIndex="9000"
            ></Loading>
            <iframe
                v-if="reportData"
                :src="reportData"
                style="width: 100%; height: 100%; border: none;min-height: 600px;"
            />

            <template #footer>
                <Button
                label="Descarregar"
                icon="pi pi-download"
                @click="downloadReport"
                />
                <Button
                label="Fechar"
                icon="pi pi-times"
                @click="showPreview = false"
                class="p-button-secondary"
                />
            </template>
        </Dialog>
    </div>
</template>

<script>

import filesService from "../../services/files.service";

export default {
  name: "PreviewReport",
  props: ["filename"],
  watch: {
    async showPreview() {
      if (this.showPreview === true) {
        this.source = this.filename;
        await this.loadReport(this.source)
      }
    },
  },
  data() {
    return {
      loading: false,
      source: null,
      reportData: null,
      reportBlob: null,
      showPreview: false
    };
  },
  beforeDestroy() {
    if (this.reportData) {
      URL.revokeObjectURL(this.reportData);
    }
  },
  methods: {
    async loadReport(fileToLoad) {
      this.loading = true;
      try {
        if (this.reportData) {
          URL.revokeObjectURL(this.reportData);
        }

        const imageBlob = await filesService.getReportsFile(fileToLoad);
        if (imageBlob) {
          this.reportData = URL.createObjectURL(imageBlob);
          this.reportBlob = imageBlob;
          this.showPreview = true;
        }
      } catch (error) {
        console.error("Failed to load report:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao carregar relatório",
          detail: "Não foi possível carregar o relatório",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    downloadReport() {
      if (!this.reportBlob) {
        console.error("Não há dados de relatório para descarregar.");
        return;
      }

      const blobUrl = URL.createObjectURL(this.reportBlob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = this.filename || 'relatorio.pdf';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 100);
    }
  },
};
</script>